import Vue from 'vue'
import Component from 'vue-class-component'
import feedStore from '../../store/feed/feed-store'

@Component({
  name: 'select-feed',
  props: ['feedType']
})
export default class FeedSelect extends Vue {
  viewStatements () {
    const query = feedStore.feedUser && feedStore.feedUser.id ? {uid: feedStore.feedUser.id.toString()} : {}
    this.$router.push ({
      path: '/statements',
      query: <{uid:string}>query
    })
  }

  viewConvos () {
    const query = feedStore.feedUser && feedStore.feedUser.id ? {uid: feedStore.feedUser.id.toString()} : {}
    this.$router.push ({
      path: '/convos',
      query: <{uid:string}>query
    })
  }
}
